module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "close-button close-button__center-content",
    on: {
      "click": _vm.click
    }
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "close-button__mini-button-container close-button__center-content "
  }, [_c('div', {
    staticClass: "close-button__mini-button close-button__center-content"
  }, [_c('div', {
    staticClass: "close-button__line close-button__first-line"
  }, [_c('div', {
    staticClass: "close-button__line-fill"
  })]), _vm._v(" "), _c('div', {
    staticClass: "close-button__line close-button__second-line"
  }, [_c('div', {
    staticClass: "close-button__line-fill"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c7dc632e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/CaseStudy/CloseButton.vue
// module id = 280
// module chunks = 0